// src/components/template/SubcategoryPage.tsx
import React from 'react';
import Layout from '@/components/layout/Layout';
import HeroSection from '@/components/ui/HeroSection';

interface SubcategoryPageProps {
  title: string;
  description: string;
  heroImage: string;
  products: Array<{
    title: string;
    imageSrc: string;
    url: string;
  }>;
}

const SubcategoryPage: React.FC<SubcategoryPageProps> = ({ 
  title, 
  description, 
  heroImage,
  products
}) => {
  return (
    <Layout
      title={`${title} | Lux Decor by Kamen`}
      description={description}
    >
      <HeroSection
        title={title}
        subtitle="Lux Decor by Kamen"
        description={description}
        ctaText="Kontaktirajte nas"
        ctaLink="/kontakt"
        backgroundImage={heroImage}
      />

      <section className="py-16 bg-luxbeige">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-semibold mb-2">Izdelki</h2>
            <p className="text-luxgray max-w-2xl mx-auto">
              Odkrijte našo ekskluzivno kolekcijo izdelkov
            </p>
            <div className="h-px w-24 bg-luxgold mx-auto mt-4"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.slice(0, 6).map((product, index) => (
              <div key={index} className="overflow-hidden">
                <div className="relative h-60 mb-4 overflow-hidden rounded-xl bg-white shadow-md border border-orange-500/30 transition-all duration-300 hover:shadow-[0_0_15px_rgba(249,115,22,0.5)] hover:border-orange-500">
                  <img 
                    src={product.imageSrc} 
                    alt={product.title} 
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-luxdark/50 to-transparent transition-opacity duration-300"></div>
                </div>
                <h3 className="text-xl font-medium text-center">{product.title}</h3>
                <div className="mt-2 flex justify-center">
                  <span className="inline-block w-10 h-0.5 bg-luxgold transition-all duration-300 group-hover:w-20"></span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default SubcategoryPage;